export const PRODUCTION = import.meta.env.VITE_PRODUCTION === 'true';
export const ENABLE_SENTRY = import.meta.env.VITE_ENABLE_SENTRY === 'true';
export const YOUTUBE_API_KEY = PRODUCTION ? import.meta.env.VITE_YOUTUBE_API_KEY_PROD : import.meta.env.VITE_YOUTUBE_API_KEY_DEV;
export const SENTRY_DSN = PRODUCTION ? import.meta.env.VITE_SENTRY_DSN_PROD : import.meta.env.VITE_SENTRY_DSN_DEV;
export const API_URL = `${import.meta.env.VITE_API_URL}/v2`;

// App device: ANDROID | IOS | PWA | WEB | SW
export const DEVICE = (() => {
    if (import.meta.env.VITE_APP_KIND === 'ANDROID') {
        return 'ANDROID';
    }

    if (import.meta.env.VITE_APP_KIND === 'IOS') {
        const metaElement = document?.querySelector('meta[name="viewport"]');
        if (metaElement) {
            metaElement.setAttribute(
                'content',
                'user-scalable=no, width=device-width, initial-scale=1, maximum-scale=5, viewport-fit=cover'
            );
        }
        return 'IOS';
    }

    if (typeof document !== 'undefined' && sessionStorage.getItem('isPWA')) {
        return 'PWA';
    }

    if (typeof document === 'undefined') {
        return 'SW';
    }

    return 'WEB';
})();

